import { ToGamePostMessage } from '../../enums';
import { LaunchData } from '../../models';
import { IntegrationBase } from './base';
import { env } from '../../environment';

export class ReplayIntegration extends IntegrationBase {

  public generateLaunchUrl(data: LaunchData): string {

    const {
      gameId, currency, currencySymbol, licenseType,
      url: launchUrl, endPoint, token,
    } = data;

    const urlString = `${launchUrl || `${env.origin}/${endPoint}/`}replay`;

    const url = new URL(urlString);

    url.searchParams.set('token', `${token}`);
    url.searchParams.set('replaymode', `${true}`);
    url.searchParams.set('licenseType', `${licenseType}`);
    url.searchParams.set('gameId', `${gameId}`);
    url.searchParams.set('currency', `${currency}`);
    url.searchParams.set('currencySymbol', `${decodeURIComponent(currencySymbol)}`);

    return url.toString();
  }

  public updateAuthInfo(launchData: LaunchData | null) {
    if (!launchData) return;
    const { token } = launchData;
    const authPayload = {
      name: ToGamePostMessage.AuthInfoUpdate,
      isAuthenticated: true,
      accessToken: token,
      payload: { hasJackpot: false }
    };
    this.rootStore.postMessageStore.sendMessage(authPayload);
  }

}
